import moment from "moment";

const IST_OFFSET_MINUTES = 330;

// Slots are stored and shown as IST weekday and hour. Only a viewer on another
// clock needs telling.
export const isOffIst = (now = moment()) => now.utcOffset() !== IST_OFFSET_MINUTES;

// The API numbers weekdays the Python way, Monday = 0. moment's isoWeekday is
// Monday = 1, so the shift is +1, never getDay()'s Sunday = 0.
export const slotDayName = (weekday, format = 'dddd') => moment().isoWeekday(weekday + 1).format(format);

export const slotTimeLabel = (hour, minute = 0) =>
  moment().hour(hour).minute(minute).format(minute ? 'h:mm A' : 'h A');

export const slotKey = ({weekday, hour, minute = 0}) => `${weekday}-${hour}-${minute}`;

export const slotLabel = slot => `${slotDayName(slot.weekday)} ${slotTimeLabel(slot.hour, slot.minute)}`;

